import styled from 'styled-components';

export const Item = styled.li`
  width: 100%;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & .selectEnable {
    display: flex;
    width: 100%;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;

    & .css-2b097c-container {
      width: 226px;
    }
  }
  ${({ disabled }) => disabled && `opacity:0.3;`}
`;

export const AddLanguageButton = styled.button`
  border: none;
  background: transparent;
  color: #1baa55;
  cursor: pointer;
  padding: 0;
  text-align: left;
  width: fit-content;

  /* Comportamientos dinámicos basados en props */
  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}

  &:hover {
    color: ${(props) => props.hoverColor || '#158F44'};
  }
`;

export const AddLanguageItem = styled.li`
  list-style: none;
  width: 100%;
  padding: 12px 0;
`;
